import { apolloProvider } from "../../vue-apollo";
const apolloClient = apolloProvider.defaultClient;
import {
  createEstablecimiento,
  getEstablecimientosPorDist,
} from "../../api/establishment";
import { getCorporacionesDist, getEmpresasDist } from "../../helpers";

const state = () => ({
  loadingSave: false,
  loading: false,
  corporacionesDistribuidor: [],
  empresasDistribuidor: [],
});

// getters
const getters = {};

// actions
const actions = {
  createEstablecimiento({ commit }, { data }) {
    commit("setLoadingSave", true);
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({ mutation: createEstablecimiento, variables: { data } })
        .then((response) => {
          console.log("response create");
          console.log(response);
          commit("setLoadingSave", false);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
          commit("setLoadingSave", false);
        });
    });
  },
  getEstablecimientosPorDist({ commit }) {
    commit("setLoading", true);
    apolloClient
      .query({ query: getEstablecimientosPorDist })
      .then(({ data }) => {
        commit(
          "setCorporacionesDistribuidor",
          getCorporacionesDist(data.getEstablecimientosPorDist)
        );
        commit(
          "setEmpresasDistribuidor",
          getEmpresasDist(data.getEstablecimientosPorDist)
        );
      })
      .catch((error) => {
        console.error(error);
        commit("setLoading", false);
      });
  },
};

// mutations
const mutations = {
  setLoadingSave(state, loading) {
    state.loadingSave = loading;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setEmpresasDistribuidor(state, empresas) {
    state.loading = false;
    state.empresasDistribuidor = empresas;
  },
  setCorporacionesDistribuidor(state, corporaciones) {
    state.loading = false;
    state.corporacionesDistribuidor = corporaciones;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
